import { mapGetters, mapActions } from 'vuex';
import { saveLoginUser, removeLoginUser, saveToken } from './localStorage';
import { account } from '../request';
export const siteMixin = {
  computed: {
    ...mapGetters([
      'siteConfig',
      'isLogin',
      'loginUser',
      'isBuy',
      'umcId',
      'defaultCid',
      'courseId',
      'courseSpecialId',
      'productId',
      'courseCatalog',
      'reviewCatalog',
      'videoId',
      'buyType',
      'catalogId',
      'pptId',
      'exerId',
      'userCourseList',
      'reviewPositionName',
      'playList',
      'srfId',
    ]),
    routeModel() {
      return process.env.VUE_APP_ROUTE_MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setSiteConfig',
      'setUserLogin',
      'setIsBuy',
      'setUmcId',
      'setDefaultCid',
      'setProductId',
      'setCourseId',
      'setCourseSpecialId',
      'setCourseCatalog',
      'setReviewCatalog',
      'setReviewPositionName',
      'setVideoId',
      'setBuyType',
      'setCatalogId',
      'setPptId',
      'setExerId',
      'setUserCourseList',
      'setPlayList',
      'setSrfId',
    ]),
    setMetaData(title, keywords, description) {
      if (title) {
        document.title = title + '-' + this.siteConfig.title;
      } else {
        document.title = this.siteConfig.title;
      }

      if (keywords) {
        document
          .querySelector('meta[name="keywords"]')
          .setAttribute('content', keywords);
      }
      if (description) {
        document
          .querySelector('meta[name="description"]')
          .setAttribute('content', description);
      }
    },
    concatImageUrl(url, width, height, isQuestion) {
      if (!url) return url;
      if (url.substring(0, 5) == '/img/') return url;
      let cdnUrl = '';
      if (url.toLowerCase().indexOf('http://') != 0) {
        if (isQuestion) {
          cdnUrl = process.env.VUE_APP_IMAGE_CDN + '/Upload/APPIMG/' + url;
        } else {
          cdnUrl = process.env.VUE_APP_IMAGE_CDN + url;
        }
      } else {
        cdnUrl = url;
      }
      if (width && height && width > 0 && height > 0) {
        cdnUrl +=
          '?x-oss-process=image/resize,m_fill,w_' + width + ',h_' + height;
      }
      return cdnUrl;
    },
    login(userInfo) {
      if ('password' in userInfo) {
        delete userInfo.password;
      }
      this.setUserLogin(userInfo);
      saveLoginUser(userInfo);
      saveToken({ preAuth: this.siteConfig.token, nextAuth: userInfo.token });
      if (this.autoLogin) {
        this.$cookies.set(
          'coksinfo',
          this.$base64.encode(userInfo.userName),
          60 * 60 * 24 * 3
        );
      } else {
        this.$cookies.set(
          'coksinfo',
          this.$base64.encode(userInfo.userName),
          0
        );
      }
      //this.kickOut();
    },
    logout() {
      saveToken({ preAuth: this.siteConfig.token, nextAuth: '' });
      this.setUserLogin({});
      removeLoginUser();
      this.$cookies.remove('coksinfo');
      this.$router.push({ path: '/' });
      // if (this.timer) {
      //     clearInterval(this.timer);
      // }
    },
    //已废弃，不用了
    kickOut() {
      //在别处登录时踢出
      if (process.env.NODE_ENV === 'development') return; //开发环境下不执行踢出策略
      if (this.timer) return;
      this.timer = setInterval(() => {
        account.getSign(this.loginUser.userId).then((res) => {
          console.log(res);
          if (res.status === 1) {
            if (res.data.sign != this.loginUser.sign) {
              clearInterval(this.timer);
              this.logout();
              this.$Message.warning('您的账户已在别的地方登录，请重新登录！');
              setTimeout(() => {
                this.reloadPage();
              }, 1500);
            }
          }
        });
      }, 1000 * 60);
    },
    //刷新页面
    reloadPage() {
      window.location.reload();
    },
    //滚动到顶部
    scrollTop(top) {
      if (!top) top = 0;
      window.scroll({ top: 0 });
    },
    //格式化价格
    formatPrice(salePrice, marketPrice) {
      //a & b 值为-1时，前端不显示价格，用于控制是否展示价格
      let a = '-1';
      let b = '-1';
      if (salePrice > 0) {
        a =
          salePrice.toString().split('.').length > 1
            ? salePrice.toFixed(2)
            : salePrice.toString();
      }
      if (marketPrice > 0) {
        b =
          marketPrice.toString().split('.').length > 1
            ? marketPrice.toFixed(2)
            : marketPrice.toString();
      }
      if (!salePrice || salePrice >= marketPrice) {
        b = '-1';
      }
      return [a, b];
    },
  },
};
